import App from 'antd/es/app/index'
import { useEffect } from 'react'
import {
  setStaticMessage,
  setStaticNotification,
} from './static-notification.ts'

/**
 * Call this hook once inside a component that is a descendant of `<App>`.
 * It captures the context-aware notification & message instances and stores
 * them in the static holder so non-React code can use them.
 */
export function useStaticNotification() {
  const { notification, message } = App.useApp()

  useEffect(() => {
    setStaticNotification(notification)
    setStaticMessage(message)
  }, [notification, message])
}
